__turbopack_context__.v({
  "map": "TeaserLargeMedia-module-scss-module__UaYBbG__map",
  "videoThumbnail": "TeaserLargeMedia-module-scss-module__UaYBbG__videoThumbnail",
});
